
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(231|612|850)$/.test(chunkId);
},
rootOutputDir: "../../../",

    };
}
